export const formatNames = (values) => {
    if (!values) return " - ";

    let formatted = values
        .split(/[_-\s]/)
        .map(v => v[0]?.toUpperCase() + v.slice(1))
        .join(' ');

    // uppercase the content inside parentheses
    formatted = formatted.replace(/\(([^)]+)\)/g, (_, inside) => `(${inside.toUpperCase()})`);

    return formatted;
};
